import { Injectable } from '@angular/core';
import { IonModal } from '@ionic/angular/standalone';

import { MarvHistoryService } from '@marv/services';

@Injectable({
  providedIn: 'root'
})
export class MarvModalService {

    constructor(
        private marvHistoryService: MarvHistoryService
    ) {}
    
    async open(modal: IonModal) {        
        const modalState = {
            modal : true,
            desc : 'fake state for modal'
        };
        this.marvHistoryService.pushState(modalState, '');   
        await modal.present();     
    }
    
    async onDidDismiss($event: any) {        
        if (!$event.detail.data?.backButton && window.history.state.modal) {   
            this.marvHistoryService.popState();
        }         
    }
    
}
